<template>
  <v-data-table :headers="headers" :items="items" :hide-default-footer="true">
    <template v-slot:item.actions="props">
      <v-btn small outlined color="error" @click="deleteDiscount(props.item.id)">
        Delete
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ["items", "orderId"],
  data() {
    return {
      search: "",
      pagination: { rowsPerPage: 20 },
      formOpen: false,
      headers: [
        { text: "Label", value: "label", align: "left" },
        { text: "Type", value: "type", align: "left" },
        { text: "Amount", value: "amount", align: "left" },
        { text: "Value", value: "value", align: "left" },
        { text: "Actions", value: "actions", align: "left" }
      ]
    };
  },
  methods: {
    deleteDiscount(id) {
      this.$store
        .dispatch("orderDiscounts/delete", {
          orderId: this.orderId,
          orderDiscountId: id
        })
        .then(result => {
          this.$emit("orderUpdate", result);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.nowrap {
  white-space: nowrap;
}
</style>
